'use client';

import { useEffect, useRef, useState } from 'react';

const LazySection = ({ children, id, className = '' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isVisible) {
                    // Use View Transitions API if supported
                    if (document.startViewTransition) {
                        document.startViewTransition(() => {
                            setIsVisible(true);
                        });
                    } else {
                        // Fallback for browsers without View Transitions support
                        setIsVisible(true);
                    }
                }
            },
            {
                rootMargin: '100px', // Start loading 100px before entering viewport
                threshold: 0.01,
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, [isVisible]);

    return (
        <div
            ref={sectionRef}
            id={id}
            data-lazy-section="true"
            className={className}
            style={{
                viewTransitionName: id ? `section-${id}` : undefined,
                willChange: isVisible ? 'auto' : 'contents',
            }}
        >
            {isVisible ? children : null}
        </div>
    );
};

export default LazySection;
